import { render, staticRenderFns } from "./ProdLagerEditor.vue?vue&type=template&id=f45f7600&"
import script from "./ProdLagerEditor.vue?vue&type=script&lang=js&"
export * from "./ProdLagerEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports